/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Limitations_TitleInputs */

const en_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Known Limitations`)
};

const de_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekannte Einschränkungen`)
};

const fr_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitations connues`)
};

const es_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitaciones conocidas`)
};

const it_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitazioni note`)
};

const nl_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekende beperkingen`)
};

const pl_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znane ograniczenia`)
};

const fi_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunnetut rajoitukset`)
};

const da_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendte begraensninger`)
};

const sv_a11y_statement_limitations_title = /** @type {(inputs: A11y_Statement_Limitations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanda begransningar`)
};

/**
* | output |
* | --- |
* | "Known Limitations" |
*
* @param {A11y_Statement_Limitations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_limitations_title = /** @type {((inputs?: A11y_Statement_Limitations_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Limitations_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_limitations_title(inputs)
	if (locale === "fr") return fr_a11y_statement_limitations_title(inputs)
	if (locale === "es") return es_a11y_statement_limitations_title(inputs)
	if (locale === "it") return it_a11y_statement_limitations_title(inputs)
	if (locale === "nl") return nl_a11y_statement_limitations_title(inputs)
	if (locale === "pl") return pl_a11y_statement_limitations_title(inputs)
	if (locale === "fi") return fi_a11y_statement_limitations_title(inputs)
	if (locale === "da") return da_a11y_statement_limitations_title(inputs)
	if (locale === "sv") return sv_a11y_statement_limitations_title(inputs)
	return en_a11y_statement_limitations_title(inputs)
});